import * as React from 'react';
import Svg, { Path, Circle, SvgProps } from 'react-native-svg';

const CartIcon = (props: SvgProps) => (
  <Svg width={192} height={192} viewBox="0 0 256 256" {...props}>
    <Path
      d="M184 184H69.8L41.9 30.6a8 8 0 0 0-7.8-6.6H16"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={16}
    />
    <Circle
      cx={80}
      cy={204}
      r={20}
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={16}
    />
    <Circle
      cx={184}
      cy={204}
      r={20}
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={16}
    />
    <Path
      d="M62.5 144h125.6a15.9 15.9 0 0 0 15.7-13.1L216 64H48"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={16}
    />
  </Svg>
);

export default CartIcon;
